import { render, staticRenderFns } from "./MassiveWarehouses.vue?vue&type=template&id=0e5278fc&lang=pug&"
import script from "./MassiveWarehouses.vue?vue&type=script&lang=js&"
export * from "./MassiveWarehouses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports